// src/utils/navigationHelper.js

let navigateFunction = null;

export const setNavigate = (navigate) => {
  navigateFunction = navigate;
};

export const navigate = (to, options = {}) => {
  if (navigateFunction) {
    navigateFunction(to, options);
  } else {
    console.error("Navigate function not set yet.");
  }
};

